import PropTypes from "prop-types";
import React from "react";

import styled from "styled-components/macro";
import theme from "theme";

SelectGroups.propTypes = {
  showGroupSelectList: PropTypes.bool,
  buttonRef: PropTypes.object,
  availableGroups: PropTypes.array,
  selectedGroupID: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(
      PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    ),
  ]),
  handleGroupSelect: PropTypes.func,
  setShowGroupSelectList: PropTypes.func,
  selectedAction: PropTypes.string,
};

export default function SelectGroups({
  showGroupSelectList,
  buttonRef,
  availableGroups,
  selectedGroupID,
  handleGroupSelect,
  setShowGroupSelectList,
  selectedAction,
}) {
  return (
    <Wrapper>
      {availableGroups.map((group, index) => {
        return (
          <ItemWrapper
            key={group.groupID}
            $level={group.level}
            onClick={() => {
              handleGroupSelect(group.groupID);
            }}
          >
            <Content>
              <span className="group-name">
                <Img src={group.photo} alt="group logo" />
                {group.groupName}
                {index === 0 && " (Everyone)"}
              </span>
              {selectedGroupID?.includes(group.groupID) ? (
                <i className="fas fa-check" style={{ paddingRight: "24px" }} />
              ) : null}
            </Content>
          </ItemWrapper>
        );
      })}
    </Wrapper>
  );
}

const Wrapper = styled.div`
  position: relative;
  width: calc(100% + 6px);
  left: -8px;
  padding-inline-start: 8px;
  padding-block-end: 16px;
  margin-block-start: 4px;
  max-height: 200px;
  overflow-x: clip;
  overflow-y: auto;
`;

const Content = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 8px;
`;

const Img = styled.img`
  width: 16px;
  height: 16px;
`;

const ItemWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  padding: 2px 2px 2px ${(p) => p.$level * 24}px;
  cursor: pointer;
  z-index: 2;

  &:before {
    content: "";
    position: absolute;
    top: 0;
    transform: translateX(-8px);
    height: 100%;
    width: calc(100% - 8px - ${(p) => p.$level * 24}px);
    background: ${theme.colors.lightGray};
    opacity: 0;
    transition: opacity 0.2s;
    border-radius: 6px;
    z-index: -1;
  }

  &:hover:not(.disabled):before {
    opacity: 1;
  }

  .group-name {
    display: flex;
    align-items: center;
    gap: 6px;
    transition: scale 0.2s;
  }

  &:hover:not(.disabled) .group-name {
    scale: 1.1;
    transform-origin: left;
  }
`;
